import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { PatientInquiryControllerApi } from "../../../services";
import { getConfigObject } from "../../../utils/utils";

interface UseGetPatientInquiryByUuidProps {
  inquiryId: string;
  xTENANTID?: string;
}

export const useGetPatientInquiryByUuid = ({
  inquiryId,
  xTENANTID,
}: UseGetPatientInquiryByUuidProps) => {
  return useQuery({
    queryKey: ["patient-inquiry-by-id", inquiryId, xTENANTID],
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
    enabled: !!inquiryId && !!xTENANTID,
    queryFn: async () =>
      await new PatientInquiryControllerApi(getConfigObject())
        .getPatientInquiryById(inquiryId, xTENANTID)
        .then((res) => res?.data),
  });
};
